module.exports = __webpack_public_path__ + "img/noFavoriteillustration(1).03b20be4.svg";